export const escapeId = (x) => x.replace(/[^a-zA-Z0-9]/g, '_');
export const formatId = (x) =>
  x.classification ? `${x.id}>${x.classification}` : x.id || x;
export const formatAndEscapeId = (x) => escapeId(formatId(x));
export const formatName = (x, delimiter = ' > ') =>
  x.classification ? `${x.name}${delimiter}${x.classification}` : x.name || x;
